// Production Firebase
export const fbConfig = {
  apiKey: 'AIzaSyA2dBxeJqoG-C6CmN55jk5P5NAFonkX0Vo',
  authDomain: 'talenttribe-live.firebaseapp.com',
  databaseURL: 'https://talenttribe-live.firebaseio.com/',
  storageBucket: 'talenttribe-live.appspot.com'
}

// Staging Firebase (for testing)
// export const fbConfig = {
//   apiKey: 'AIzaSyACr1B4hrISuKaPzYtaimwgJTwiLTecuLY',
//   authDomain: 'talenttribe-staging.firebaseapp.com',
//   databaseURL: 'https://talenttribe-staging.firebaseio.com/',
//   storageBucket: 'talenttribe-staging.appspot.com'
// };

export const reduxfbConfig = {
  userProfile: 'users',
  enableLogging: false,
}

export default { fbConfig, reduxfbConfig }


// WEBPACK FOOTER //
// ./src/config/firebase.js